import React from "react";

import Back from "../widgets/Back";

export default class AppointmentNote extends React.Component {
  setView = (type) => {
    localStorage.setItem("appointmentHideButtons", type);

    this.forceUpdate();
  };

  render() {
    return (
      <div className="settings-body">
        <div className="title">
          <Back />
          <div className="name">Appointment calendar view</div>
        </div>
        <div className="body">
          <div className="list-group">
            <span onClick={() => this.setView("false")} className="list-group-item">
              {Boolean(localStorage.getItem("appointmentHideButtons") === "false") && (
                <div className="pull-right">&#10004;</div>
              )}
              Visible
            </span>
            <span onClick={() => this.setView("true")} className="list-group-item">
              {Boolean(localStorage.getItem("appointmentHideButtons") === "true") && (
                <div className="pull-right">&#10004;</div>
              )}
              Hide
            </span>
          </div>
        </div>
      </div>
    );
  }
}
